import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import useValue from '../hooks/use-value'
import { useShouldConditionallyRender } from '@morningtrain/react-helpers'

function WhenModelValue (props) {
  const {
    name,
    condition,
    negate = false,
    children
  } = props

  const value = useValue(name)

  const [shouldRender] = useShouldConditionallyRender(value, condition, negate)

  if (!shouldRender) {
    return null
  }

  return children
}

WhenModelValue.propTypes = {
  name: PropTypes.string.isRequired,
  condition: PropTypes.any,
  negate: PropTypes.bool
}

export default observer(WhenModelValue)
